import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { customSortByname } from '../utils/utils';

export default (state = initialState.desmond, action) => {
  switch (action.type) {
    case `${ActionTypes.SET_DESMOND_PROBLEM_DATA}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.problemData));
      if (!temp[action.problemSlug]) {
        temp[action.problemSlug] = action.payload;
      } else {
        temp[action.problemSlug] = {
          ...temp[action.problemSlug],
          ...action.payload,
        };
      }
      return {
        ...state,
        problemData: temp,
      };
    }
    case `${ActionTypes.RUN_DESMOND_TYPE_TEST_CASES}_SET_LISTINER`: {
      const { slug, non_sample_testcases, sample_testcases } = action.problem;
      const temp = JSON.parse(JSON.stringify(state.testCasesResult));
      let runTestCasesStatus = [];
      if (Array.isArray(sample_testcases)) {
        runTestCasesStatus = sample_testcases
          .sort(customSortByname)
          .map(testCase => ({
            name: testCase.name,
            id: testCase.id,
            status: null,
          }));
      }
      if (Array.isArray(non_sample_testcases)) {
        runTestCasesStatus = runTestCasesStatus
          .concat(
            non_sample_testcases.map(nonSampleTestCase => ({
              name: nonSampleTestCase.name,
              id: nonSampleTestCase.id,
              status: null,
            }))
          )
          .sort(customSortByname);
      }
      if (!temp[slug]) {
        temp[slug] = {
          solutionId: action.solutionId,
          runTestCasesStatus,
        };
      } else {
        temp[slug] = {
          ...temp[slug],
          solutionId: action.solutionId,
          runTestCasesStatus,
        };
      }

      return { ...state, testCasesResult: temp };
    }

    case ActionTypes.RESET_RUN_DESMOND_DATA: {
      const testCasesTemp = { ...state.testCasesResult };
      const { problemSlug } = action;

      if (testCasesTemp[problemSlug])
        testCasesTemp[problemSlug] = {
          solutionId: testCasesTemp[problemSlug].solutionId,
        };
      return { ...state, testCasesResult: testCasesTemp };
    }

    case ActionTypes.RUN_CODE_TEST_CASES_RESULT: {
      const availableSlugs = Object.keys(state.testCasesResult);
      const tempData = action.data
        ? JSON.parse(JSON.stringify(action.data))
        : {};

      const problemSlug = availableSlugs.find(slug => {
        if (
          state.testCasesResult[slug].solutionId &&
          state.testCasesResult[slug].solutionId === tempData.solution_id
        )
          return true;
        return false;
      });

      if (problemSlug) {
        const temp = JSON.parse(JSON.stringify(state.testCasesResult));
        if (!tempData.testcases) delete tempData.status;

        temp[problemSlug] = { ...temp[problemSlug], ...tempData };
        if (Array.isArray(temp[problemSlug].runTestCasesStatus)) {
          const testCaseIndex = temp[problemSlug].runTestCasesStatus.findIndex(
            testCase => {
              return testCase.id === tempData?.TestCaseRunDetails?.id;
            }
          );

          if (testCaseIndex >= 0) {
            if (temp[problemSlug].runTestCasesStatus[testCaseIndex])
              temp[problemSlug].runTestCasesStatus[testCaseIndex] = {
                ...temp[problemSlug].runTestCasesStatus[testCaseIndex],
                ...tempData.TestCaseRunDetails,
              };
          }
        }
        return { ...state, testCasesResult: temp };
      }
      return state;
    }
    case `${ActionTypes.RUN_DESMOND_CODE_CUSTOM_INPUT}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      if (!temp[action.problemSlug]) {
        temp[action.problemSlug] = { apiResponse: action.payload };
      } else {
        temp[action.problemSlug] = {
          ...temp[action.problemSlug],
          apiResponse: action.payload,
        };
      }
      return { ...state, customInputResult: temp };
    }

    case `${ActionTypes.RUN_PROJECT}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.runProject));

      temp[action.problemSlug] = {
        apiResponse: action.payload,
      };

      return { ...state, runProject: temp };
    }
    case `${ActionTypes.RUN_PROJECT}_RESULT`: {
      const availableSlugs = Object.keys(state.runProject);
      const tempData = action.data;

      const problemSlug = availableSlugs.find(slug => {
        if (
          state.runProject[slug]?.apiResponse?.sid &&
          state.runProject[slug]?.apiResponse?.sid === tempData.sid
        )
          return slug;
        return null;
      });

      if (problemSlug) {
        return {
          ...state,
          runProject: { ...state.runProject, [problemSlug]: tempData },
        };
      }
      return state;
    }

    case ActionTypes.DESMOND_PROBLEM_SAVE_REPO: {
      const newState = { ...state };
      newState.solution = {
        ...newState.solution,
        [action.payload.problemSlug]: action.payload.data,
      };

      return newState;
    }
    case ActionTypes.RUN_VERIFY_TEST_CASES_RESULT: {
      const temp = JSON.parse(JSON.stringify(state.customInputResult));
      const tempo = JSON.parse(JSON.stringify(state.testCasesResult));
      const availableSlugs = Object.keys(temp);
      const problemSlug = availableSlugs.find(slug => {
        if (
          temp[slug].apiResponse &&
          temp[slug].apiResponse.sid &&
          temp[slug].apiResponse.sid === action.data.sid
        )
          return true;
        return false;
      });

      if (temp[problemSlug]) {
        temp[problemSlug] = { ...temp[problemSlug], ...action.data };
        tempo[problemSlug] = { ...tempo[problemSlug], ...action.data };
      }
      return { ...state, customInputResult: temp, testCasesResult: tempo };
    }
    default:
      return state;
  }
};
